<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQueryCus">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['factory']" >
              <a-select showSearch optionFilterProp="children" v-model="queryParam.factoryId" :options="factoryOptions" :placeholder="language['common.pleaseInput']+language['factory']" allowClear>
               </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['legalperson']">
              <a-select showSearch optionFilterProp="children" v-model="queryParam.legalpersonId" :options="legalpersonOptions" :placeholder="language['common.pleaseInput']+language['legalperson']" allowClear>
               </a-select>
            </a-form-item>
          </a-col>
          
          <template v-if="toggleSearchStatus">
            
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="language['businessGroupName']">
                <a-select 
                :placeholder="language['common.pleaseInput']+language['businessGroupName']"
                v-model="queryParam.businessGroupId"
                :options="businessGroupOptions"
                @change="handleGroupVal" allowClear>
                </a-select>
              </a-form-item>
            </a-col>
                  
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="language['businessUnitName']">
                <a-select 
                :placeholder="language['common.pleaseInput']+language['businessUnitName']"
                v-model="queryParam.businessUnitId"
                :options="businessUnitOptions"
                allowClear>
                </a-select>
              </a-form-item>
            </a-col>
            
            
            
            <a-col :xl="10" :lg="11" :md="12" :sm="24">
              <a-form-item :label="language['inspectTime']">
                <j-date :placeholder="language['common.chooseStartDate']" class="query-group-cust" v-model="queryParam.startTime"></j-date>
                <span class="query-group-split-cust"></span>
                <j-date :placeholder="language['common.chooseEndDate']" class="query-group-cust" v-model="queryParam.endTime"></j-date>
              </a-form-item>
            </a-col>
            
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQueryCus" icon="search">{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchResetCus" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->
    
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button type="primary" icon="download" @click="handleExportXls('罚扣隐患分析')" >{{language['common.exportButton']}}</a-button>
      <!-- <a-button @click="handlerUpdate('1')" type="primary" :disabled="disabledState">复查维护</a-button>
      <a-button @click="handlerUpdate('2')" type="primary" :disabled="disabledState">申请延期</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown> -->
    </div>

    <!-- table区域-begin -->
    <a-tabs @change="callback">
      <a-tab-pane key="1" :tab="language['list.info.title']">
        <div>
          <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
            <i class="anticon anticon-info-circle ant-alert-icon"></i> {{language['common.choosed']}} <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>{{language['common.item']}}
            <a style="margin-left: 24px" @click="onClearSelected">{{language['common.clear']}}</a>
          </div>

          <a-table
            ref="table"
            size="middle"
            bordered
            rowKey="id"
            class="j-table-force-nowrap"
            :scroll="{x:true}"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="false"
            :loading="loading"
            :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
            @change="handleTableChange">

            <span slot="action" slot-scope="text, record">
              <a @click="handleEdit(record)">{{language['common.edit']}}</a>

              <a-divider type="vertical" />
              <a-dropdown>
                <a class="ant-dropdown-link">{{language['common.more']}} <a-icon type="down" /></a>
                <a-menu slot="overlay">
                  <a-menu-item>
                    <a @click="handleDetail(record)">{{language['common.detailsButton']}}</a>
                  </a-menu-item>
                  <a-menu-item>
                    <a-popconfirm :title="language['common.deleteConfirmInfo']" @confirm="() => handleDelete(record.id)">
                      <a>{{language['common.delete']}}</a>
                    </a-popconfirm>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </span>

          </a-table>
        </div>
      </a-tab-pane>

      <a-tab-pane key="2" :tab="language['pie.chart']">
          <template>
            <div>
              <h2 style="margin-left: 700px">{{this.businessUnitName}}</h2>
              <v-chart :forceFit="true" :height="height" :data="data" :scale="scale" >
                <v-tooltip :showTitle="false" dataKey="item*percent" />
                <v-axis />
                <v-legend dataKey="item" />
                <v-pie
                  position="percent"
                  color="item"
                  :vStyle="pieStyle"
                  :label="labelConfig"
                />
                <v-coord type="theta" />
              </v-chart>
            </div>
          </template>

      </a-tab-pane>

      <a-tab-pane key="3" :tab="language['histogram']">
          <template>
            <div style="overflow-x: scroll;">
              <v-chart :forceFit="false" width="2200" :height="height" :data="data2">
                <v-tooltip />
                <v-axis />
                <v-legend />
                <v-stack-bar position="事业处*数量" color="name" />
              </v-chart>
            </div>
        </template>
      </a-tab-pane>
    </a-tabs>

    <!-- <ep-danger-check-modal ref="modalForm" @ok="modalFormOk"/> -->
  </a-card>
</template>

<script>
  import { getAction, postAction,downFile } from '@/api/manage'
   import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  // import EpDangerCheckModal from './modules/EpDangerCheckModal'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'
  import '@/assets/less/TableExpand.less'
  import { filterObj } from '@/utils/util';

  export default {
    name: "EpDangerCheckList",
    // mixins:[JeecgListMixin],
    components: {
      
    },
    data () {
      return {
        sourceData:[],
        data:[],
        data2:[],
        scale:[],
        height: 400,
        fields:[],
        pieStyle: {
          stroke: "#fff",
          lineWidth: 1
        },
        labelConfig: ['percent', {
          offset: -40,
          textStyle: {
            rotate: 0,
            textAlign: 'center',
            shadowBlur: 2,
            shadowColor: 'rgba(0, 0, 0, .45)'
          }
        }],
        businessUnitName:'',
        description: '罚扣隐患分析表',
        /* 查询条件-请不要在queryParam中声明非字符串值的属性 */
      queryParam: {
        appCode:'env_audit'
      },
      /* 数据源 */
      dataSource:[],
      // 表格缓存的数据 - 用来点击取消时回显数据
      cacheData: [],
      /* 分页参数 */
      ipagination:{
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + "-" + range[1] + " 共" + total + "条"
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      /* 排序参数 */
      isorter:{
        column: 'createTime',
        order: 'desc',
      },
      /* 筛选参数 */
      filters: {},
      /* table加载状态 */
      loading:false,
      /* table选中keys*/
      selectedRowKeys: [],
      /* table选中records*/
      selectionRows: [],
      /* 查询折叠 */
      toggleSearchStatus:true,
        url: {
          list: "/epm/report/getDangerPenaltyReportTo",
          exportXlsUrl: "/epm/report/exportPenaltyToXls",
          queryFactoryList: '/sys/epFactory/list',
          queryLegalpersonList: '/sys/epPerson/list',
          queryEmployeeList: '/sys/employee/list',
          queryBusinessGroupList: "/sys/sysDepart/queryBusinessGroupList",
          queryBusinessUnitList: "/sys/sysDepart/queryBusinessUnitList"
        },
        dictOptions:{},
        superFieldList:[],
        factoryOptions: [],
        legalpersonOptions:[],
        inspectUserOptions:[],
        disabledState:true,
        id:'',
        businessGroupOptions:[],
        businessUnitOptions:[],
        tempKey: 1
      }
    },
    created() {
       this.initQueryDate();
      this.searchQueryCus(1);
      this.initfactoryList();
      this.initlegalpersonList();
      this.initemployeeList();
      this.initBusinessGroupList();
      
    },

    computed: {
      language() {
        return this.$store.getters.language
      },

      columns(){
              if(this.language){
                return   [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:this.language['factory'],
            align:"center",
            dataIndex: 'factoryName',
          },
          {
            title:this.language['legalperson'],
            align:"center",
            dataIndex: 'personName',
          },
          {
            title:this.language['businessGroupName'],
            align:"center",
            dataIndex: 'businessGroupName'
          },

          {
            title:this.language['businessUnitName'],
            align:"center",
            dataIndex: 'businessUnitName'
          },
          {
            title:this.language['selfCheck.dangerNum'],
            align:"center",
            dataIndex: 'dangerNum'
          },
          {
            title:this.language['report.penaltyDangerNum'],
            align:"center",
            dataIndex: 'penaltyDangerNum'
          },
          {
            title:this.language['report.unPenaltyDangerNum'],
            align:"center",
            dataIndex: 'unPenaltyDangerNum'
          },
          {
            title:this.language['report.penaltyPercent'],
            align:"center",
            dataIndex: 'penaltyPercent'
          }
        ]
            }
      },
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    methods: {
      initQueryDate(){
        this.queryParam = {startTime: this.getOneMonthDate(),endTime: this.getNowDate()}
      },
      getNowDate()
      {
          let month =parseInt(new Date().getMonth())+1;
          return new Date().getFullYear() + "-" + month + "-" + new Date().getDate();
      },
      getOneMonthDate(){
          const dates = new Date()
          dates.setMonth(dates.getMonth() - 1)
          let pastMonth = dates.getMonth() + 1
          let pastDay = dates.getDate()
          if (pastMonth >= 1 && pastMonth <= 9) {
            pastMonth = '0' + pastMonth
          }
          if (pastDay >= 0 && pastDay <= 9) {
            pastDay = '0' + pastDay
          }
          const endDate = dates.getFullYear() + '-' + pastMonth + '-' + pastDay
          return endDate
          //return new Date().getFullYear() + "-" + new Date().getMonth() + "-" + new Date().getDate();
       },
      
      initBusinessGroupList(){
        getAction(this.url.queryBusinessGroupList,{applicationCode:'env_audit'}).then(res=>{
          if(res.success){
            this.businessGroupOptions = res.result.map((item,index,arr)=>{
              let c = {label:item.departName, value: item.id+""}
              return c;
            })
            console.log('this.businessGroupOptions: ',this.businessGroupOptions)
          }
        })
      },
      handleGroupVal(val){
        getAction(this.url.queryBusinessUnitList,{id:val}).then(res=>{
          if(res.success){
            this.businessUnitOptions = res.result.map((item,index,arr)=>{
              let c = {label:item.departName, value: item.id+""}
              return c;
            })
            
          }
        })
      },
      searchQueryCus(arg){
        if(!this.url.list){
        this.$message.error("请设置url.list属性!")
        return
      }
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1;
      }
      this.queryParam.appCode = 'env_audit';
      var params = this.getQueryParams();//查询条件
      this.loading = true;
      postAction(this.url.list, params).then((res) => {
        if (res.success) {
          //update-begin---author:zhangyafei    Date:20201118  for：适配不分页的数据列表------------
          const result = res.result.records || res.result
          this.dataSource = result.map((v, i)=>{
            v.key = i + 1;
            return v;
          });
          // this.cacheData = JSON.parse(JSON.stringify(res.result.records));
          
          if(res.result.total){
            this.ipagination.total = res.result.total;
          }else{
            this.ipagination.total = 0;
          }
          // this.dealPie();
          this.callback(this.tempKey);
        }else{
          this.$message.warning(res.message)
        }
      }).finally(() => {
        this.loading = false
      })
      },

      callback(key) {
        this.tempKey = key;
        if(key==2){
          this.dealPie();
        }
        if(key==3){
          this.dealBar();
        }
      },
      //饼壮图
      dealPie(){
          //处理图表数据
          this.sourceData =[];
          this.fields =[];
          let attr=['penaltyDangerNum','unPenaltyDangerNum'];
          if(this.dataSource.length<=1){
              this.data= []
              return
          }
          this.dataSource.map((item,index,arr)=>{
            this.businessUnitName=item.businessUnitName;
            attr.forEach((k)=>{
              if(k=='penaltyDangerNum'){
                   let c = {item:this.language['report.penaltyDangerNum'], count: item.penaltyDangerNum};
                   this.sourceData.push(c);
                } 
                if(k=='unPenaltyDangerNum'){
                   let c = {item:this.language['report.unPenaltyDangerNum'], count: item.unPenaltyDangerNum};
                   this.sourceData.push(c);
                }
              })
            })
          console.log('this.sourceData==>',this.sourceData);
          const DataSet = require('@antv/data-set');
           this.scale = [{
              dataKey: 'percent',
              min: 0,
              formatter: '.0%',
            }];

            const dv = new DataSet.View().source(this.sourceData);
            dv.transform({
              type: 'percent',
              field: 'count',
              dimension: 'item',
              as: 'percent'
            });
             this.data = dv.rows;
      },
      //柱状图
      dealBar(){
          //处理图表数据2
          this.sourceData =[];
          this.fields =[];
          let attr=['penaltyDangerNum','unPenaltyDangerNum'];
          let levela={name:this.language['report.penaltyDangerNum']};
          let levelb={name:this.language['report.unPenaltyDangerNum']};
          if(this.dataSource.length<=1){
              this.data2 =[]
              return
          }
          
          attr.forEach((k)=>{
            this.dataSource.map((item,index,arr)=>{
              if(item.businessUnitName!='合计'){
                if(k=='penaltyDangerNum'){
                    let a ='\n\n\n\n'+ item.factoryName+',\n'+item.personName+',\n'+item.businessGroupName+',\n'+item.businessUnitName;
                    let b = item.penaltyDangerNum;
                    levela[a] = b ;
                } 
                if(k=='unPenaltyDangerNum'){
                    let a ='\n\n\n\n'+ item.factoryName+',\n'+item.personName+',\n'+item.businessGroupName+',\n'+item.businessUnitName;
                    let b = item.unPenaltyDangerNum;
                    levelb[a] = b ;
                }
              }
              })
            })
              this.sourceData.push(levela);
              this.sourceData.push(levelb);
          console.log('this.sourceData==>',this.sourceData);
            this.dataSource.forEach((item)=>{
              if(item.businessUnitName!='合计'){
                this.fields.push('\n\n\n\n'+item.factoryName+',\n'+item.personName+',\n'+item.businessGroupName+',\n'+item.businessUnitName);
                }
              })
           console.log('this.fields==>',this.fields); 
            const DataSet = require('@antv/data-set');
            const dv2 = new DataSet.View().source(this.sourceData);
            dv2.transform({
              type: 'fold',
              fields: this.fields,
              key: '事业处',
              value: '数量',
            });
             this.data2 = dv2.rows;
      },

      getQueryParams() {
      //获取查询条件
      let sqp = {}
      if(this.superQueryParams){
        sqp['superQueryParams']=encodeURI(this.superQueryParams)
        sqp['superQueryMatchType'] = this.superQueryMatchType
      }
      var param = Object.assign(sqp, this.queryParam, this.isorter ,this.filters);
      param.field = this.getQueryField();
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      //稽查标识
      param.inspectFlag =0;
      return filterObj(param);  
     },

     getQueryField() {
      //TODO 字段权限控制
      var str = "id,";
      this.columns.forEach(function (value) {
        str += "," + value.dataIndex;
      });
      return str;
    },

    searchResetCus() {
      this.queryParam = {}
      this.queryParam.appCode = 'env_audit';
      this.searchQueryCus(1);
    },

    handleToggleSearch(){
      this.toggleSearchStatus = !this.toggleSearchStatus;
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },

    handleExportXls(fileName){
      if(!fileName || typeof fileName != "string"){
        fileName = "导出文件"
      }
      let param = this.getQueryParams();
      if(this.selectedRowKeys && this.selectedRowKeys.length>0){
        param['selections'] = this.selectedRowKeys.join(",")
      }
      console.log("导出参数",param)
      downFile(this.url.exportXlsUrl,param).then((data)=>{
        if (!data) {
          this.$message.warning("文件下载失败")
          return
        }
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(new Blob([data],{type: 'application/vnd.ms-excel'}), fileName+'.xls')
        }else{
          let url = window.URL.createObjectURL(new Blob([data],{type: 'application/vnd.ms-excel'}))
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', fileName+'.xls')
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link); //下载完成移除元素
          window.URL.revokeObjectURL(url); //释放掉blob对象
        }
      })
    },
    
      handleTableChange(pagination, filters, sorter) {
      //分页、排序、筛选变化时触发
      //TODO 筛选
      console.log(pagination)
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
      }
      this.ipagination = pagination;
      this.searchQueryCus();
    },

      onSelectChange(selectedRowKeys, selectionRows) {
        this.selectedRowKeys = selectedRowKeys;
        this.selectionRows = selectionRows;
        this.id = this.selectionRows[0].id;
        this.disabledState = this.selectionRows.length !== 1
      },

      /* handlerUpdate(key){
        this.$refs.modalForm.key = key;
        this.$refs.modalForm.id = this.id
        this.$refs.modalForm.add();
        this.$refs.modalForm.title = "整改维护";
        this.$refs.modalForm.disableSubmit = false;
      }, */

      //初始化厂区字典
      initfactoryList(){
		  let para={pageNo:1,pageSize:1000};
        getAction(this.url.queryFactoryList,para).then(res=>{
          if(res.success){
            this.factoryOptions = res.result.records.map((item,index,arr)=>{
              let c = {label:item.factoryName, value: item.id+""}
              return c;
            })
            console.log('this.factoryOptions: ',this.factoryOptions)
          }
        })
      },

      //初始化法人字典
      initlegalpersonList(){
		  let para = {pageNo:1,pageSize:10000};
        getAction(this.url.queryLegalpersonList,para).then(res=>{
          if(res.success){
            this.legalpersonOptions = res.result.records.map((item,index,arr)=>{
              let c = {label:item.legalpersonName, value: item.id+""}
              return c;
            })
            console.log('this.legalpersonOptions: ',this.legalpersonOptions)
          }
        })
      },
      //初始化人员典
      initemployeeList(){
        getAction(this.url.queryEmployeeList).then(res=>{
          if(res.success){
            this.inspectUserOptions = res.result.records.map((item,index,arr)=>{
              let c = {label:item.realname, value: item.id+""}
              return c;
            })
            console.log('this.inspectUserOptions: ',this.inspectUserOptions)
          }
        })
      },
      backDepartInfo(info) {
        this.model.departIds = this.model.selecteddeparts;
        this.nextDepartOptions = info.map((item,index,arr)=>{
          let c = {label:item.text, value: item.value+""}
          return c;
        })
      },
      initDictConfig(){
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
  /deep/ .g2-tooltip{
      width: 200px !important;
    }
  
</style>